import styled from "styled-components";

import {
  dateFormatted,
  getTimeAMPM,
  numberWithCommas,
} from "modules/functions";
import * as css from "styles/CssVariables.js";
import coinsIcon from "assets/img/icons/coins-icon.svg";
import dollarIcon from "assets/img/icons/dollar-icon.svg";
import bulbIcon from "assets/img/icons/tip-bulb.svg";
import discoverIcon from "assets/img/icons/menu-discover-white.svg";
import referralsIcon from "assets/img/icons/menu-referrals.svg";
import exchangeIcon from "assets/img/icons/icons8-exchange-small.svg";

const Wallet = styled.div`
  position: absolute;
  top: 36px;
  left: 0;
  width: 100%;
  box-sizing: border-box;

  margin: 0;
  padding: 0 7px;

  display: flex;
  flex-direction: column;

  opacity: ${(props) => (props.display ? 100 : 0)};

  transition: 0.2s;
`;

const WalletBalances = styled.div`
  width: 100%;
  padding: 15px 10px 10px;
  box-sizing: border-box;
  margin-top: 8px;

  background: ${css.BLUE_BOX_GRADIENT};
  border-radius: 10px;

  flex-direction: column;
  gap: 30px;
`;

const WalletBoxTitle = styled.div`
  width: 100%;

  font-size: 13px;
  font-weight: ${css.BOX_TITLE_FONT_WEIGHT};

  display: flex;
  flex-direction: column;
`;

const LeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const LeftTop = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const Balances = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Balance = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const BalanceIcon = styled.div`
  width: 22px;
  min-width: 22px;
  height: 22px;
`;

const BalanceText = styled.div`
  font-size: 16px;
  font-weight: 500;
`;

const BalanceButtonWrap = styled.div`
  padding-top: 3px;
`;

const CashBalanceWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const ButtonRoundCircle = styled.div`
  width: 20px;
  min-width: 20px;
  height: 20px;
  box-sizing: border-box;

  border-radius: 50%;
  background: ${css.BRAND_YELLOW};
  border: 0px;

  display: flex;
  justify-content: center;
  align-items: center;
`;

const ConvertButtonRoundIcon = styled.div`
  width: 12px;
  height: 12px;

  transition: 0.2s;

  background-image: ${`url(${exchangeIcon})`};
  background-repeat: no-repeat;
  background-size: cover;
`;

const RightColumn = styled.div``;

const TipBox = styled.div`
  margin-top: 20px;

  max-width: 315px;
  padding: 15px 8px;
  width: 100%;
  box-sizing: border-box;

  background: ${css.FLAT_BOX_BACKGROUND};
  border-radius: ${css.BOX_RADIUS_SECONDARY};

  flex: 0.5;

  display: flex;
  flex-direction: column;
  gap: 14px;
`;

const TipWrap = styled.div`
  display: flex;
`;

const TipIcon = styled.div`
  width: 16px;
  min-width: 16px;
  height: 16px;
`;

const TipText = styled.div`
  padding-left: 6px;

  font-size: 13px;
  font-weight: 500;

  flex: 1;
`;

const TipColumns = styled.div`
  display: flex;
  gap: 0px;
`;

const TipColumn = styled.div`
  max-width: 130px;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;

  flex: 0.5;
`;

const TipColumnIcon = styled.div`
  width: 18px;
  min-width: 18px;
  height: 18px;
`;

const TipColumnText = styled.div`
  line-height: 125%;
  font-size: 11px;
`;

const SectionTitle = styled.div`
  margin-top: 8px;
  margin-bottom: 6px;

  font-size: 13px;
  font-weight: 500;
`;

const TransactionListBox = styled.div`
  width: 100%;
  min-height: 280px;
  padding: 12px 8px;
  box-sizing: border-box;

  background: ${css.BLUE_BOX_GRADIENT};
  border-radius: 10px;

  display: flex;
  justify-content: space-between;
  flex-direction: column;
  gap: 10px;
`;

const TableWrap = styled.div`
  width: 100%;
  padding-bottom: 5px;
  margin-bottom: -5px;

  overflow-x: auto;
`;

const ListTable = styled.table`
  width: 100%;
  min-width: 220px;
  /* max-width: 700px; */
`;

const TableHead = styled.thead``;

const Label = styled.th`
  padding-bottom: 6px;

  font-size: 13px;
  font-weight: 400;
  text-align: left;
`;

const TableBody = styled.tbody``;

const Cell = styled.td`
  font-size: 11px;
`;

const AmountBox = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

const DetailsWrap = styled.div`
  width: 100%;
  max-width: 210px;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Badge = styled.div`
  height: 16px;
  padding: 0 9px;

  font-size: 10px;

  border-radius: 11px;
  background: ${css.POSITIVE_GREEN};

  display: flex;
  justify-content: center;
  align-items: center;
`;

const ButtonSmall = styled.div`
  box-sizing: border-box;
  height: 18px;
  padding: 0 10px;

  background: ${css.BRAND_YELLOW};
  border-radius: 14px;
  border: 0;

  font-size: 9px;
  font-weight: 400;
  color: ${css.DARK_BLUE};
  white-space: nowrap;
  line-height: 1;

  transition: 0.2s;

  display: flex;
  align-items: center;
`;

export default ({ display }) => {
  const transactions = [
    {
      amount: 200,
      created_at: "2025-04-07T07:22:12.988896+00:00",
      data: {},
      id: "00acd684-ab44-4806-9ec3-94dbd21b444d",
      type: "rewardsPayout",
    },
  ];

  const transactionList = transactions.map((transaction) => {
    const { id, created_at, type, data, amount } = transaction;

    let typeText;
    let details;

    switch (type) {
      case "rewardsPayout":
        typeText = "Coins found";
        break;
      case "referralReward":
        typeText = "Referral reward";
        details = data.referral_username;
        break;
    }

    return (
      <tr key={id}>
        <Cell>
          {dateFormatted(new Date(created_at), false) +
            ", " +
            getTimeAMPM(new Date(created_at))}
        </Cell>
        <Cell>{typeText}</Cell>
        <Cell>
          <AmountBox>
            <Badge green={amount >= 0 ? 1 : 0}>
              {numberWithCommas(amount)}
            </Badge>
          </AmountBox>
        </Cell>
        <Cell>
          <DetailsWrap>{details}</DetailsWrap>
        </Cell>
      </tr>
    );
  });
  return (
    <Wallet display={display}>
      <WalletBalances>
        <LeftColumn>
          <LeftTop>
            <WalletBoxTitle>Your Balance</WalletBoxTitle>
            <Balances>
              <Balance>
                <BalanceIcon>
                  <img src={coinsIcon} style={{ width: "100%" }} />
                </BalanceIcon>
                <BalanceText>32,607 Coins</BalanceText>
                <BalanceButtonWrap>
                  <ButtonRoundCircle>
                    <ConvertButtonRoundIcon />
                  </ButtonRoundCircle>
                </BalanceButtonWrap>
              </Balance>
              <CashBalanceWrap>
                <Balance>
                  <BalanceIcon>
                    <img src={dollarIcon} style={{ width: "100%" }} />
                  </BalanceIcon>
                  <BalanceText>713.44 USD</BalanceText>
                </Balance>
              </CashBalanceWrap>
            </Balances>
          </LeftTop>
        </LeftColumn>
        <RightColumn>
          <TipBox>
            <TipWrap>
              <TipIcon>
                <img src={bulbIcon} alt="Tip" style={{ width: "100%" }} />
              </TipIcon>
              <TipText>How to Earn Free Coins</TipText>
            </TipWrap>
            <TipColumns>
              <TipColumn>
                <TipColumnIcon>
                  <img src={discoverIcon} alt="Tip" style={{ width: "100%" }} />
                </TipColumnIcon>
                <TipColumnText>
                  Find coins by exploring opportunities
                </TipColumnText>
                <ButtonSmall>Discover</ButtonSmall>
              </TipColumn>
              <TipColumn>
                <TipColumnIcon>
                  <img
                    src={referralsIcon}
                    alt="Tip"
                    style={{ width: "100%" }}
                  />
                </TipColumnIcon>
                <TipColumnText>
                  Earn a reward by referring new users
                </TipColumnText>
                <ButtonSmall>Referral Program</ButtonSmall>
              </TipColumn>
            </TipColumns>
          </TipBox>
        </RightColumn>
      </WalletBalances>
      <SectionTitle>Coins Transactions</SectionTitle>
      <TransactionListBox>
        <TableWrap className="table-wrap">
          <ListTable>
            <TableHead>
              <tr>
                <Label width="75px">Date</Label>
                <Label width="65px">Type</Label>
                <Label width="30px">Amount</Label>
              </tr>
            </TableHead>
            <TableBody>{transactionList}</TableBody>
          </ListTable>
        </TableWrap>
      </TransactionListBox>
    </Wallet>
  );
};
